import React, { useEffect, useState } from 'react';
import { useTypedTranslation } from '@app/hooks';
import {
    PasslyButton,
    ErrorBlock,
    ButtonSubmit,
    PasslyValidatedPassword,
    PasslyTextField
} from '@app/components';
import { SetIsPasswordChanged, DataForPswResetSmsResponse } from '@app/models';
import { returnToLogin, onSubmitChangePassword } from '../helpers';
import { basicService } from '@app/services';

interface IProps {
    userDataForChangePassword: DataForPswResetSmsResponse;
    setIsPasswordChanged: SetIsPasswordChanged;
}

export const ChangePassword: React.SFC<IProps> = ({ userDataForChangePassword, setIsPasswordChanged }) => {
    const { translation } = useTypedTranslation();
    const usernameQueryString = basicService.getQueryVariable('user');
    const [confirmPassword, setConfirmPassword] = useState<string>('');
    const [isError, setIsError] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>('');

    const [validatedPassword, setValidatedPassword] = useState('');
    const [confirmPasswordError, setConfirmPasswordError] = useState(false);
    const [disablePrimaryBtn, setDisablePrimaryBtn] = useState(true);
    const [validatedPasswordError, setValidatedPasswordError] = useState(false);

    useEffect(() => {
        if (confirmPassword !== '' && confirmPassword !== validatedPassword) {
            setConfirmPasswordError(true);
        } else {
            setConfirmPasswordError(false);
        }
    }, [confirmPassword, validatedPassword]);

    useEffect(() => {
        if (!validatedPasswordError && !confirmPasswordError && confirmPassword !== '' && validatedPassword !== '') {
            setDisablePrimaryBtn(false);
        } else {
            setDisablePrimaryBtn(true);
        }
    }, [validatedPasswordError, confirmPasswordError, confirmPassword, validatedPassword]);

    const onConfirmPasswordChange = (e: any) => {
        const { value } = e.target;

        setConfirmPassword(value);

        if (value !== validatedPassword) {
            return false;
        }
    };

    const onValidatedPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let value = event.target.value;

        setValidatedPassword(value);
    };

    return (
        <div className='reset-password'>
            <h1>{translation('RESET_TITLE')}</h1>
            <ErrorBlock className='reset-password__error' isError={isError} errorMessage={errorMessage} />
            <p className='reset-password__form-text'>{translation('RESET_SMS_SENT_MESSAGE')}</p>

            <form
                onSubmit={onSubmitChangePassword(
                    userDataForChangePassword,
                    validatedPassword,
                    usernameQueryString,
                    setIsPasswordChanged,
                    setErrorMessage,
                    setIsError
                )}
            >
                <div className='form__row'>
                    <PasslyValidatedPassword
                        value={validatedPassword}
                        onChange={onValidatedPasswordChange}
                        label={'RESET_NEW_PASSWORD'}
                    />
                </div>
                <div className='form__row'>
                    <PasslyTextField
                        fullWidth
                        label={'CONFIRM_NEW_PASSWORD'}
                        value={confirmPassword}
                        onChange={onConfirmPasswordChange}
                        id='userConfirmPassword-input'
                        name='confirmPassword'
                        type='password'
                        required
                        error={confirmPasswordError}
                        helperText={confirmPasswordError && translation('PASSWORDS_DONT_MATCH')}
                    />
                </div>
                <div className='reset-password__buttons'>
                    <ButtonSubmit
                        className='reset-password__button-submit'
                        isLoad={false}
                        buttonText={translation('RESET_PASSWORD')}
                        isDisabled={disablePrimaryBtn}
                        disableRipple={true}
                    />
                    <PasslyButton className='reset-password__button-cancel' onClick={returnToLogin()} color='primary' disableRipple={true}>
                        {translation('CANCEL')}
                    </PasslyButton>
                </div>
            </form>
        </div>
    );
};
